import React, { useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MomentsUser from "../../components/MomentsUser";
import MainContainer from "../../components/MainContainer";
import { Paper, Box, Typography } from "@material-ui/core";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import PageHelpGuide from "../../components/PageHelpGuide";
import { MOMENTS_HELP_DATA } from "../../constants/pageHelp/momentsHelp";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    height: "100%",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    borderRadius: 16,
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32 !important" : theme.palette.background.paper,
    backdropFilter: "blur(12px)",
  },
  headerWrapper: {
    marginTop: 28,
    marginBottom: 30,
    paddingLeft: 20,
    paddingRight: 20,
    flexShrink: 0,
  },
  pageTitle: {
    fontWeight: 700,
    letterSpacing: "-0.5px",
    color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main,
  },
  contentWrapper: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    padding: theme.spacing(1),
    paddingTop: 0,
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
  },
}));

const ChatMoments = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { user } = useContext(AuthContext);

  if (user.profile === "user" && user.allowRealTime === "disabled") {
    return <ForbiddenPage />;
  }

  return (
    <MainContainer>
      <Paper className={classes.mainPaper} variant="outlined">
        <Box
          display="flex"
          alignItems="center"
          className={classes.headerWrapper}
        >
          <PageHelpGuide
            helpData={MOMENTS_HELP_DATA}
            tooltipText={i18n.t("momentsUser.helpTooltip") || "Guía y Ayuda de Asistencias (Haz clic para ver)"}
          />
          <Box style={{ width: 14 }} />
          <Typography
            variant="h5"
            className={classes.pageTitle}
          >
            {i18n.t("servicePanel.allowRealTime") || "Asistencias"}
          </Typography>
        </Box>

        <Box className={classes.contentWrapper}>
          <MomentsUser />
        </Box>
      </Paper>
    </MainContainer>
  );
};

export default ChatMoments;
